import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { tAny } from '@/i18n'

/** Sets "<Title> · SchoolEduca"; the title is translated (English source text is the key). */
export function useDocumentTitle(title: string | undefined): void {
  const { i18n } = useTranslation()
  useEffect(() => {
    if (title) document.title = `${tAny(title)} · SchoolEduca`
  }, [title, i18n.language])
}
